{
    "coordinates": [
        29.28607123338938,
        30.127281436428206
    ],
    "tooltip": "Wadi al Hitan",
    "title": "Wadi al Hitan (Temple Member)",
    "country": "Egypt",
    "period": "Paleogene"
}
